module.exports = __webpack_public_path__ + "img/category-title01.8e157146.png";